import React, { HTMLAttributes } from "react";
import StyledTableHead from "./TableHead.styled";
import TableCell from "../../atoms/TableCell/TableCell.styled";
import { H5 } from "../../atoms/H/H.styled";

export interface ITableRow extends HTMLAttributes<HTMLTableRowElement> {
  /** Table row values */
  values: Array<{ label: string; colspan: number }>;
}

const TableRow = ({ values, ...props }: ITableRow) => (
  <StyledTableHead>
    {values.map((value) => (
      <TableCell colSpan={value.colspan}>
        <H5>{value.label}</H5>
      </TableCell>
    ))}
  </StyledTableHead>
);

export default TableRow;
